import "./product-details-borneo-cta.scss";
import { track } from "jiffy-analytics";

const $getCtaWrapper = () => document.querySelector(".js-borneo-cta");
const $getCtaButton = $wrapper => $wrapper.querySelector(".js-borneo-cta-button");
const $getCtaLink = $wrapper => $wrapper.querySelector(".js-borneo-cta-link");

export default () => {
  const $wrapper = $getCtaWrapper();
  if (!$wrapper) return;

  const $ctaButton = $getCtaButton($wrapper);
  const $ctaLink = $getCtaLink($wrapper);

  $ctaButton.addEventListener("click", () => {
    track("borneo_editor_open_button_clicked", { source: "blank_pdp_cta" });
  });

  $ctaLink.addEventListener("click", () => {
    track("borneo_editor_open_button_clicked", { source: "blank_pdp_cta" });
  });
};
